var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"btn-edit-icon",attrs:{"src":(_vm.publicPath + "/img/edit_icon.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }